import React from 'react'

const AboutMe = () => {



  return (
    <div className="flex flex-col items-center justify-center h-screen bg-gradient-to-r from-blue-500 via-blue-700 to-blue-900 dark:bg-white">
      <div className="p-12 bg-white dark:bg-gray-800 dark:text-white rounded-lg shadow-md text-center">
        <div className="flex flex-col items-center justify-center gap-4 mb-4 pt-8">
          <div className='flex justify-center items-center gap-x-2 w-[50vw]'>
            <span className='text-xl'>
              Hi, my name is Moshe Ben Shimol. I'm a student studying Computer Science at Tel Hai College,
              specializing in Web Development.I am a team player with a strong motivation to learn.
              I love to program, gaming And Basketball.
            </span>
         </div>
      </div>
    </div>
  </div>
  )
}
 
export default AboutMe